export const validator = ({ validator, value }) => {

    try {
        switch (validator) {
            case 'email': {
                return (
                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value) || false
                )
            }
            case 'linkedin_url': {
                return (
                    /^(https?:\/\/)?(www\.)?linkedin\.com\/(in|pub|company|school)\/[a-zA-Z0-9_-]+\/?$/.test(value) || false
                )
            }
            case 'non_null_string': {
                return !!value && value?.trim()?.length>0;
            }
            case 'number': {
                return typeof value === 'number'
            }
            case 'phone_number': {
                return !!value && String(value ?? '').length>=10 && String(value ?? '').length<=15
            }
            case 'non_null': {
                return !!value
            }
            default: {
                return false;
            }
        }
    } catch (error) {
        return false;
    }

}